import { action, computed, makeObservable, observable } from 'mobx';

import { routes } from 'config/routes';
import { TableCellEntity } from 'entities/TableCell';
import {
  CellControllerKind,
  NavigationControllerEntity,
  TableControllersEntity,
} from 'entities/TableControllers';
import { TableRowEntity } from 'entities/TableRow';

import { ITableFactoryRowModel } from '../../table/TableFactoryRowModel/interface';
import { ITableControllerBase } from '../interface';

export type TableCellControllerParams<
  T extends TableControllersEntity = TableControllersEntity
> = TableCellEntity<T> & {
  parentRowModel: ITableFactoryRowModel | null;
};
type PrivateFields = '_value';

export default class TableNavigationController
  implements ITableControllerBase<string>
{
  constructor(record: TableCellControllerParams<NavigationControllerEntity>) {
    this._value = record.controller;
    this._initialValue = record.controller;
    this._params = record;
    makeObservable<TableNavigationController, PrivateFields>(this, {
      _value: observable.ref,
      controllerValue: computed,
      setValue: action.bound,

      toServerFormat: computed,

      canGoToFlatList: computed,

      reset: action.bound,
    });
  }

  private _value: NavigationControllerEntity['controller'];

  private readonly _initialValue: NavigationControllerEntity['controller'];

  private readonly _params: TableCellControllerParams<NavigationControllerEntity>;

  readonly isUpdateBlocked = false;

  get controllerKind() {
    return CellControllerKind.NAVIGATION;
  }

  get controllerValue() {
    return this._value;
  }

  /** Флаг, который показывает, можем ли мы переходить на плоский лист*/
  get canGoToFlatList(): boolean {
    return this._value.value.flat.isActive;
  }

  get toServerFormat(): string {
    return this._value.value.payload;
  }

  /** Конфигурируем роут для перехода на плоскую таблицу */
  computeFlatTableRoute = (formId: number): string => {
    return routes.form.formReview.flat.createPath({
      rootId: (this._params.parentRowModel?.entity as TableRowEntity).rowId,
      id: String(formId),
    });
  };

  destroy() {}

  reset(): void {
    this._value = this._initialValue;
  }

  setValue(): void {}
}
